import useRequest from '@/websdk/utils/request';

export default (function () {
  const { exec, isRequestSuccessed } = useRequest({
    url: '/api/system/roles',
    name: 'POST_ROLE',
    method: 'POST',
  });

  return [exec, isRequestSuccessed];
});
